(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rcl-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const button = document.getElementById('rcl-chat-launcher');
  const panel = document.getElementById('rcl-chat-panel');
  const close = document.getElementById('rcl-chat-close');
  const status = document.getElementById('rcl-chat-status');
  if (!button || !panel) return;
  let timer;
  const hide = () => {
    panel.hidden = true;
    button.hidden = false;
    button.setAttribute('aria-expanded', 'false');
    button.focus();
    clearTimeout(timer);
  };
  const ready = () => {
    const api = window.HubSpotConversations;
    if (!api || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.hidden = false;
    api.on('widgetLoaded', () => { status.hidden = true; clearTimeout(timer); });
    button.addEventListener('click', () => {
      panel.hidden = false;
      button.hidden = true;
      button.setAttribute('aria-expanded', 'true');
      close.focus();
      if (!api.widget.status().loaded) {
        status.hidden = false;
        status.textContent = status.dataset.loading;
        api.widget.load();
        timer = setTimeout(() => { if (!api.widget.status().loaded) status.textContent = status.dataset.delayed; }, 12000);
      }
    });
    close.addEventListener('click', hide);
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  };
  if (window.HubSpotConversations) ready();
  else (window.hsConversationsOnReady = window.hsConversationsOnReady || []).push(ready);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rcl-cloud-fabric"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rcl-cloud-fabric')) {
  customElements.define('rcl-cloud-fabric', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const figures = [...this.querySelectorAll('[data-fabric-variant]')];
        const valid = id => figures.some(f => f.dataset.fabricVariant === String(id));
        const controls = [...document.querySelectorAll('[name="id"]')];
        const selected = controls.find(el => valid(el.value) && (el.type === 'radio' ? el.checked : el.tagName === 'SELECT'));
        const hidden = controls.find(el => valid(el.value) && el.type === 'hidden');
        const urlId = new URL(location.href).searchParams.get('variant');
        const id = selected?.value || hidden?.value || (valid(urlId) ? urlId : this.dataset.initial);
        const match = figures.find(f => f.dataset.fabricVariant === String(id));
        figures.forEach(f => { f.hidden = f !== match || f.hasAttribute('data-fabric-missing'); });
        this.toggleAttribute('data-missing', !match || match.hasAttribute('data-fabric-missing'));
      };
      this.onChange = () => { this.update(); setTimeout(this.update, 150); };
      document.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onChange);
      this.timer = setInterval(this.update, 400);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onChange);
      clearInterval(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
